// Helpers para o fluxo do plano "Básico": origem da anamnese e identificação do kit.

const ANAMNESE_ORIGIN_KEY = "anamneseOrigin";

// Remove diacríticos (acentos) sem depender de um literal regex com caracteres combinantes.
function stripDiacritics(str) {
  let result = "";
  for (const ch of String(str || "").normalize("NFD")) {
    const code = ch.codePointAt(0);
    const isCombiningMark = code >= 0x0300 && code <= 0x036f;
    if (!isCombiningMark) result += ch;
  }
  return result;
}

export function normalizeKitVersion(version) {
  return stripDiacritics(version).toUpperCase().trim();
}

export function isBasicoKit(kitOrVersion) {
  const version = kitOrVersion?.version ?? kitOrVersion?.label ?? kitOrVersion;
  // A API retorna "My Formula Básica" (não apenas "Básico"), então checamos
  // se o termo aparece em qualquer lugar da string normalizada.
  return normalizeKitVersion(version).includes("BASIC");
}

export function isAnamneseFromBasico() {
  try {
    return localStorage.getItem(ANAMNESE_ORIGIN_KEY) === "basico";
  } catch {
    return false;
  }
}

export function setAnamneseOriginBasico() {
  try {
    localStorage.setItem(ANAMNESE_ORIGIN_KEY, "basico");
  } catch {
    // noop
  }
}

export function clearAnamneseOrigin() {
  try {
    localStorage.removeItem(ANAMNESE_ORIGIN_KEY);
  } catch {
    // noop
  }
}
